export const goBack = ($window) => {
  "ngInject";

  return {
    restrict: "A",
    link: (scope, element, attrs, ngModel) => {
      element.bind("click", () => {
        $window.history.back();
      });
    },
  };
};



// WEBPACK FOOTER //
// ./src/app/common/components/go-back/go-back.directive.js